import { FC } from 'react';

import {
  BadgeTooltipWrapper,
  DraftTooltip,
  TooltipDescription,
  TooltipLink
} from './Wrapper';
import { RenderLink, TooltipWrapperProps } from './types';

export const permissionTooltip = ({ renderLink = () => null }: RenderLink) => (
  <>
    <TooltipDescription>To edit the password</TooltipDescription>
    <TooltipDescription isInline>settings, </TooltipDescription>
    <TooltipDescription isInline>
      {renderLink(<TooltipLink margin="0 0 0 5px">click here.</TooltipLink>)}
    </TooltipDescription>
  </>
);

export const landingTooltip = ({ renderLink = () => null }: RenderLink) => (
  <>
    <TooltipDescription>To edit the Landing</TooltipDescription>
    <TooltipDescription isInline>page, </TooltipDescription>
    <TooltipDescription isInline>
      {renderLink(<TooltipLink margin="0 0 0 5px">click here.</TooltipLink>)}
    </TooltipDescription>
  </>
);

export const embeddedTooltip = ({ renderLink = () => null }: RenderLink) => (
  <>
    <TooltipDescription>To change the embed</TooltipDescription>
    <TooltipDescription isInline>settings, </TooltipDescription>
    <TooltipDescription isInline>
      {renderLink(<TooltipLink margin="0 0 0 5px">click here.</TooltipLink>)}
    </TooltipDescription>
  </>
);

export const unHostedVideoDraftTooltip = ({
  renderLink = () => null
}: RenderLink) => (
  <>
    <TooltipDescription>This project has not been</TooltipDescription>
    <TooltipDescription>published yet. To publish it,</TooltipDescription>
    <TooltipDescription>
      {renderLink(<TooltipLink margin="0 0 0 5px">go to Editor.</TooltipLink>)}
    </TooltipDescription>
  </>
);

export const hostedVideoDraftTooltip = ({
  renderLink = () => null
}: RenderLink) => (
  <>
    <TooltipDescription>This project has been</TooltipDescription>
    <TooltipDescription>changed. To update, publish</TooltipDescription>
    <TooltipDescription isInline>it</TooltipDescription>
    <TooltipDescription isInline>
      {renderLink(<TooltipLink margin="0 0 0 5px">in the Editor.</TooltipLink>)}
    </TooltipDescription>
  </>
);

const DraftTooltipWrapper: FC<TooltipWrapperProps> = props => (
  <DraftTooltip {...props} />
);

const EmbedTooltipWrapper: FC<TooltipWrapperProps> = props => (
  <BadgeTooltipWrapper left={35} {...props} />
);

const PasswordTooltipWrapper: FC<TooltipWrapperProps> = props => (
  <BadgeTooltipWrapper left={40} contentWidth={185} {...props} />
);

const LandingTooltipWrapper: FC<TooltipWrapperProps> = props => (
  <BadgeTooltipWrapper left={25} contentWidth={170} {...props} />
);

const BadgeTooltip: FC<TooltipWrapperProps> = ({
  tooltipTitle,
  ...tooltipProps
}) => {
  const isDraftTooltip = tooltipTitle === 'Draft';
  const isPasswordTooltip = tooltipTitle === 'Password';
  const isLandingPageTooltip = tooltipTitle === 'Page';

  switch (true) {
    case isDraftTooltip:
      return <DraftTooltipWrapper {...tooltipProps} />;
    case isPasswordTooltip:
      return <PasswordTooltipWrapper {...tooltipProps} />;
    case isLandingPageTooltip:
      return <LandingTooltipWrapper {...tooltipProps} />;
    default:
      return <EmbedTooltipWrapper {...tooltipProps} />;
  }
};

export default BadgeTooltip;
